import { GetServerSideProps, NextPage } from "next";
import { Charts, ChartArt } from "../../chart.constants";
import { ChartRelease, ChartDropdownItem, ChartUnavailableReason } from "../../chart.models";
import { getChartReleaseAndDates, chartPageCacheControl } from "../../services/server/page-data.service";
import ChartPage from "../../components/chart-page.component";
import { handleRouterQueries } from "../../services/client/url.service";
import { useEffect } from "react";
import { useRouter } from "next/router";

type PageProps = {
	chartRelease?: ChartRelease
	allChartReleaseDates: Array<ChartDropdownItem>
	unavailableReason?: ChartUnavailableReason
}

const CHART = Charts.TopSpins;

const TopSpinsChart: NextPage<PageProps> = ({chartRelease, allChartReleaseDates, unavailableReason}) => {
	const router = useRouter();
	useEffect(() => {
		let isComponentMounted = true;
		if (chartRelease && isComponentMounted) {
			const query = router.query;
			handleRouterQueries(CHART.path, chartRelease, query);
		}
		return () => { isComponentMounted = false; };
	}, [chartRelease]);

	return <ChartPage
		chartRelease={chartRelease}
		name={CHART.name}
		metaTitle="Pandora's Top Spins Chart"
		description={"The Pandora Top Spins chart shows which releases in the last 30 days got the most streams on Pandora."}
		art={ChartArt.TopSpins}
		chartID={CHART.id}
		weekOfText={"Week of "}
		allChartReleases={allChartReleaseDates}
		unavailableReason={unavailableReason}
	/>;
};

export const getServerSideProps: GetServerSideProps<PageProps> = async ({res, ...context}) => {
	// getChartReleaseAndDates absorbs charts API failures, so this never throws and the
	// page never 500s - but the cache header depends on what came back, so it is set after.
	const props: PageProps = await getChartReleaseAndDates(context, CHART.id);

	res.setHeader("Cache-Control", chartPageCacheControl(props));

	return { props };
};

export default TopSpinsChart;